const rudderstack = require("./rudderstack").rudderstack;
const $ = require("jquery");

const initRudderstackAnalytics = () => {
  $(document).on("click", "[data-track-event='login-button-click']", () => {
    rudderstack.trackLoginCtaClicked();
  });

  $(document).on("click", "[data-track-event='signup-button-click']", function (e) {
    const buttonText = $(this).text().trim();
    rudderstack.trackSignUpCtaClicked({ ctaText: buttonText });

    if (this.tagName === "A") {
      const anonymousId = rudderstack.getAnonymousId();

      if (anonymousId) {
        e.preventDefault();
        const url = new URL(this.href, window.location.origin);
  
        url.searchParams.set("ajs_aid", anonymousId);
        window.location.href = url.toString();
      }
    }
  });

  $(document).on("click", "[data-track-event='logo-click']", () => {
    rudderstack.trackLogoClicked();
  });

  $(document).on("click", "[data-track-event='forgot-company-login-click']", () => {
    rudderstack.trackForgotCompanyLoginClicked();
  });

  $(document).on("click", "[data-track-event='download-accessibility-report-click']", () => {
    rudderstack.trackDownloadAccessibilityReportClicked();
  });
};

module.exports = {
  initRudderstackAnalytics,
};
